import React, { useState } from 'react'; 
import { Box, Button, Typography, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Select, MenuItem, FormControl, Checkbox, Pagination, Autocomplete, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from '@mui/material';
import { LicenseInfo } from '@mui/x-license-pro';
import ReplayIcon from '@mui/icons-material/Replay';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SearchIcon from '@mui/icons-material/Search';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TransformIcon from '@mui/icons-material/Transform';
import * as XLSX from 'xlsx';
import verificareToken from '../VerificareToken';
import FileUpload from '../FileUpload'; 

LicenseInfo.setLicenseKey(
  '6d6829e50ec611ef52701c7161ea0bd1Tz0xMTQ0NzAsRT0xNzgxMzA4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

const ImportCustom = () => {
  const { token } = verificareToken();
  const [excelData, setExcelData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [columnMapping, setColumnMapping] = useState({});
  const [selectedColumns, setSelectedColumns] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [step, setStep] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 100;
  
  // Find & Replace
  const [findText, setFindText] = useState('');
  const [replaceText, setReplaceText] = useState('');
  const [findResults, setFindResults] = useState(null);
  const [showReplaceDialog, setShowReplaceDialog] = useState(false);
  
  // Filtru global
  const [filterText, setFilterText] = useState('');
  const [filteredRows, setFilteredRows] = useState([]);
  
  // Sortare
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' sau 'desc'
  
  // Transformări
  const [selectedTransformColumn, setSelectedTransformColumn] = useState('');
  const [selectedTransformation, setSelectedTransformation] = useState('');
  
  // Users pentru maparea Jurist
  const [users, setUsers] = useState([]);
  const [rowUserAssignments, setRowUserAssignments] = useState({}); // { rowIndex: userId }
  const [globalUserAssignment, setGlobalUserAssignment] = useState(null);
  const [showUserAssignment, setShowUserAssignment] = useState(false); // Toggle pentru a arăta assignment-ul

  // Lista coloanelor interne disponibile
  const availableColumns = [
    { value: '', label: '-- Neselectat --' },
    { value: 'numarDosar', label: 'Număr dosar' },
    { value: 'numarIntern', label: 'Număr intern' },
    { value: 'tipDosar', label: 'Tip dosar' },
    { value: 'dataDosar', label: 'Dată dosar' },
    { value: 'valoareDosar', label: 'Valoare dosar' },
    { value: 'valoareRecuperata', label: 'Valoare recuperată' },
    { value: 'materieDosar', label: 'Materie dosar' },
    { value: 'obiectDosar', label: 'Obiect dosar' },
    { value: 'stareDosar', label: 'Stare dosar' },
    { value: 'solutieDosar', label: 'Soluție dosar' },
    { value: 'detaliiSolutie', label: 'Detalii soluție' },
    { value: 'dataSolutionare', label: 'Dată soluționare' },
    { value: 'jurist', label: 'Jurist' },
    { value: 'observatiiDosar', label: 'Observații dosar' },
    { value: 'calitateClientDosar', label: 'Calitate client dosar' },
    { value: 'adresaClientDosar', label: 'Adresă client dosar' },
    { value: 'cnpClientDosar', label: 'CNP Client dosar' },
    { value: 'cuiClientDosar', label: 'CUI client dosar' },
    { value: 'recomClientDosar', label: 'RECOM client dosar' },
    { value: 'ibanClientDosar', label: 'IBAN client dosar' },
    { value: 'utilizatorDosar', label: 'Utilizator dosar' },
    { value: 'instantaDosar', label: 'Instanță dosar' },
    { value: 'dataDosar2', label: 'Dată dosar' },
    { value: 'dosareConexe', label: 'Dosare conexe' },
    { value: 'observatii', label: 'Observații' },
    { value: 'departament', label: 'Departament' },
    { value: 'rol', label: 'Rol' },
    { value: 'parteDosar', label: 'Parte dosar' },
    { value: 'parteAdversa', label: 'Parte adversă' },
    { value: 'clientDosar', label: 'Client dosar' },
    { value: 'campPersonalizat1', label: 'Câmp personalizat 1' },
    { value: 'campPersonalizat2', label: 'Câmp personalizat 2' },
    { value: 'campPersonalizat3', label: 'Câmp personalizat 3' },
    { value: 'campPersonalizat4', label: 'Câmp personalizat 4' },
    { value: 'campPersonalizatN', label: 'Câmp personalizat n' },
  ];
 
  const handleReset = () => {
    setExcelData(null);
    setColumns([]);
    setRows([]);
    setColumnMapping({});
    setSelectedColumns({});
    setSelectedRows({});
    setStep(1);
    setCurrentPage(1);
    setFindText('');
    setReplaceText('');
    setFindResults(null);
    setFilterText('');
    setFilteredRows([]);
    setRowUserAssignments({});
    setGlobalUserAssignment(null);
    setShowUserAssignment(false);
  };

  // Fetch users
  React.useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${window.API_URL}users?users_from_all_common_groups=1`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        const { data } = await response.json();
        setUsers(data.users);
      } catch (error) {
        console.error("Eroare la preluarea utilizatorilor", error);
      }
    };

    if (token) {
      fetchUsers();
    }
  }, [token]);

  const handleColumnMappingChange = (excelColumn, internalColumn) => {
    setColumnMapping(prev => ({
      ...prev,
      [excelColumn]: internalColumn
    }));
  };

  const handleColumnSelectionChange = (excelColumn, isSelected) => {
    setSelectedColumns(prev => ({
      ...prev,
      [excelColumn]: isSelected
    }));
  };

  const handleColumnHeaderClick = (excelColumn) => {
    setSelectedColumns(prev => ({
      ...prev,
      [excelColumn]: !prev[excelColumn]
    }));
  };

  const handleRowSelectionChange = (rowIndex, isSelected) => {
    setSelectedRows(prev => ({
      ...prev,
      [rowIndex]: isSelected
    }));
  };

  const handleSelectAllRows = () => {
    const allSelected = Object.keys(selectedRows).length === rows.length && 
                        Object.values(selectedRows).every(Boolean);
    const newSelectedRows = {};
    rows.forEach((_, index) => {
      newSelectedRows[index] = !allSelected;
    });
    setSelectedRows(newSelectedRows);
  };

  const handleNextStep = () => {
    setStep(2);
  };

  const handlePrevStep = () => {
    setStep(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Determină câte rânduri să afișeze cu paginare
  const getDisplayRows = () => {
    // Aplică sortarea mai întâi
    const sortedData = getSortedRows();
    // Apoi filtrarea
    const dataToDisplay = filterText ? sortedData.filter(row => {
      return columns.some(col => {
        const cellValue = String(row[col] || '');
        return cellValue.toLowerCase().includes(filterText.toLowerCase());
      });
    }) : sortedData;
    
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return dataToDisplay.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    const sortedData = getSortedRows();
    const dataToDisplay = filterText ? sortedData.filter(row => {
      return columns.some(col => {
        const cellValue = String(row[col] || '');
        return cellValue.toLowerCase().includes(filterText.toLowerCase());
      });
    }) : sortedData;
    return Math.ceil(dataToDisplay.length / rowsPerPage);
  };

  const getActualRowIndex = (displayIndex) => {
    const displayRow = getDisplayRows()[displayIndex];
    return rows.findIndex(row => row === displayRow);
  };

  // Verifică dacă poate merge la pasul următor
  const canProceedToNextStep = () => {
    // Verifică dacă există cel puțin o coloană selectată
    const hasSelectedColumn = Object.values(selectedColumns).some(Boolean);
    if (!hasSelectedColumn) return false;

    // Verifică dacă cel puțin o coloană selectată are mapare setată (nu '')
    const hasValidMapping = columns.some(col => 
      selectedColumns[col] && columnMapping[col] && columnMapping[col] !== ''
    );
    if (!hasValidMapping) return false;

    // Verifică dacă există cel puțin un rând selectat
    const hasSelectedRow = Object.values(selectedRows).some(Boolean);
    if (!hasSelectedRow) return false;

    return true;
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
  
      if (jsonData.length > 0) {
        // Extrage toate coloanele din prima linie
        const columnNames = Object.keys(jsonData[0]);
        setColumns(columnNames);
        setRows(jsonData);
        setExcelData(true);
        // Inițializează toate coloanele ca fiind DEZACTIVATE
        const initialSelection = {};
        columnNames.forEach(col => {
          initialSelection[col] = false;
        });
        setSelectedColumns(initialSelection);
        // Inițializează toate rândurile ca fiind selectate
        const initialRowSelection = {};
        jsonData.forEach((_, index) => {
          initialRowSelection[index] = true;
        });
        setSelectedRows(initialRowSelection);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // Filtrează coloanele selectate pentru pasul 2
  const getSelectedColumnsData = () => {
    return columns.filter(col => selectedColumns[col]);
  };

  const getMappedColumnLabel = (excelColumn) => {
    const mappedValue = columnMapping[excelColumn];
    if (!mappedValue) return '-- Neselectat --';
    const found = availableColumns.find(col => col.value === mappedValue);
    return found ? found.label : '-- Neselectat --';
  };

  // Generează JSON-ul pentru import
  const generateImportJson = () => {
    // Filtrează doar coloanele selectate și mapate
    const selectedMappedColumns = columns.filter(col => 
      selectedColumns[col] && columnMapping[col] && columnMapping[col] !== ''
    );

    // Filtrează doar rândurile selectate
    const selectedRowsData = rows.filter((_, index) => selectedRows[index]);

    // Construiește datele mapate
    const mappedData = selectedRowsData.map((row, originalIndex) => {
      const mappedRow = {};
      selectedMappedColumns.forEach(excelCol => {
        const internalField = columnMapping[excelCol];
        mappedRow[internalField] = row[excelCol];
      });
      
      // Adaugă user assignment dacă există (fie că Jurist e mapat, fie că e activat manual)
      const actualRowIndex = rows.indexOf(row);
      if (shouldShowUserAssignment() && rowUserAssignments[actualRowIndex]) {
        mappedRow.assignedUserId = rowUserAssignments[actualRowIndex];
      }
      
      return mappedRow;
    });

    const jsonPayload = {
      totalRows: selectedRowsData.length,
      totalColumns: selectedMappedColumns.length,
      columnMapping: selectedMappedColumns.reduce((acc, col) => {
        acc[col] = columnMapping[col];
        return acc;
      }, {}),
      hasJuristMapping: isJuristColumnMapped(),
      hasManualUserAssignment: showUserAssignment,
      data: mappedData
    };

    return JSON.stringify(jsonPayload, null, 2);
  };

  const [importProgress, setImportProgress] = useState(null); // null | 'loading' | 'success' | 'error'
  const [importMessage, setImportMessage] = useState('');
  const [importPercent, setImportPercent] = useState(0);
  const [importCompleted, setImportCompleted] = useState(0);
  const [importTotal, setImportTotal] = useState(0);
  const [importErrors, setImportErrors] = useState([]);
  const [retryingRow, setRetryingRow] = useState(null);

  const handleStartImport = async () => {
    const json = generateImportJson();
    const payload = JSON.parse(json);
    const allData = payload.data;
    const totalRows = allData.length;
    const chunkSize = 10;

    setImportProgress('loading');
    setImportMessage('');
    setImportPercent(0);
    setImportCompleted(0);
    setImportTotal(totalRows);
    setImportErrors([]);

    let processedCount = 0;
    const errorList = [];

    // Trimitem câte 1 request per dosar, dar maxim 10 simultan (în paralel)
    for (let i = 0; i < totalRows; i += chunkSize) {
      const chunk = allData.slice(i, i + chunkSize);

      const promises = chunk.map(async (dosarData, idx) => {
        const rowIndex = i + idx;
        try {
          const response = await fetch(`${window.API_URL}importCustom`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              ...payload,
              totalRows: 1,
              data: [dosarData]
            })
          });

          const responseData = await response.json();

          if (response.ok) {
            return { success: true, rowIndex };
          } else {
            return { success: false, rowIndex, message: responseData.message || 'Nu a putut fi importat', dosarData };
          }
        } catch (error) {
          return { success: false, rowIndex, message: 'Problemă de conexiune', dosarData };
        }
      });

      const results = await Promise.all(promises);

      results.forEach(result => {
        processedCount++;
        if (!result.success) {
          errorList.push({
            row: result.rowIndex + 1,
            message: result.message,
            dosarData: result.dosarData
          });
        }
      });

      // Actualizăm progresul
      setImportCompleted(processedCount);
      setImportPercent(Math.round((processedCount / totalRows) * 100));
      setImportErrors([...errorList]);

      // Pauză de 500ms între calupuri (nu la ultimul)
      if (i + chunkSize < totalRows) {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    // Final
    const successCount = processedCount - errorList.length;
    if (errorList.length === 0) {
      setImportProgress('success');
      setImportMessage(`Import realizat cu succes! ${totalRows} dosare procesate.`);
    } else if (successCount > 0) {
      setImportProgress('success');
      setImportMessage(`${successCount} dosare importate cu succes. ${errorList.length} dosare necesită atenție.`);
    } else {
      setImportProgress('error');
      setImportMessage('Dosarele nu au putut fi importate. Verificați conexiunea și reîncercați.');
    }
  };

  const handleCloseJsonModal = () => {
    setImportProgress(null);
    setImportMessage('');
    setImportPercent(0);
    setImportCompleted(0);
    setImportTotal(0);
    setImportErrors([]);
    setRetryingRow(null);
  };

  const handleRetryImport = async (errorItem) => {
    setRetryingRow(errorItem.row);
    const json = generateImportJson();
    const payload = JSON.parse(json);

    try {
      const response = await fetch(`${window.API_URL}importCustom`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...payload,
          totalRows: 1,
          data: [errorItem.dosarData]
        })
      });

      const responseData = await response.json();

      if (response.ok) {
        // Eliminăm din lista de atenționări
        setImportErrors(prev => prev.filter(e => e.row !== errorItem.row));
        setImportCompleted(prev => prev); // forțăm re-render
      } else {
        // Actualizăm mesajul
        setImportErrors(prev => prev.map(e =>
          e.row === errorItem.row ? { ...e, message: responseData.message || 'Nu a putut fi importat' } : e
        ));
      }
    } catch (error) {
      setImportErrors(prev => prev.map(e =>
        e.row === errorItem.row ? { ...e, message: 'Problemă de conexiune' } : e
      ));
    } finally {
      setRetryingRow(null);
    }
  };

  // Find & Replace functions
  const handleFind = () => {
    if (!findText) return;
    
    let count = 0;
    const locations = [];
    
    rows.forEach((row, rowIndex) => {
      columns.forEach(col => {
        const cellValue = String(row[col] || '');
        if (cellValue.toLowerCase().includes(findText.toLowerCase())) {
          count++;
          locations.push({ row: rowIndex, col, value: cellValue });
        }
      });
    });
    
    setFindResults({ count, locations });
    if (count > 0) {
      setShowReplaceDialog(true);
    } else {
      alert('Nu s-au găsit rezultate.');
    }
  };

  const handleReplace = () => {
    if (!findResults || findResults.count === 0) return;
    
    const newRows = [...rows];
    findResults.locations.forEach(({ row, col }) => {
      const cellValue = String(newRows[row][col] || '');
      const regex = new RegExp(findText, 'gi');
      newRows[row][col] = cellValue.replace(regex, replaceText);
    });
    
    setRows(newRows);
    setShowReplaceDialog(false);
    setFindResults(null);
    setFindText('');
    setReplaceText('');
    alert(`${findResults.count} înlocuiri efectuate cu succes!`);
  };

  const handleCancelReplace = () => {
    setShowReplaceDialog(false);
    setFindResults(null);
  };

  // Filter functions
  const handleFilterChange = (value) => {
    setFilterText(value);
    setCurrentPage(1);
  };

  const handleClearFilter = () => {
    setFilterText('');
    setFilteredRows([]);
    setCurrentPage(1);
  };

  const getTotalRowsCount = () => {
    const sortedData = getSortedRows();
    if (!filterText) return sortedData.length;
    
    return sortedData.filter(row => {
      return columns.some(col => {
        const cellValue = String(row[col] || '');
        return cellValue.toLowerCase().includes(filterText.toLowerCase());
      });
    }).length;
  };

  // Sortare
  const handleSort = (column) => {
    if (sortColumn === column) {
      // Schimbă direcția dacă e aceeași coloană
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Nouă coloană, sortare ascendentă
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const getSortedRows = () => {
    if (!sortColumn) return rows;
    
    const sorted = [...rows].sort((a, b) => {
      const aVal = String(a[sortColumn] || '');
      const bVal = String(b[sortColumn] || '');
      
      if (sortDirection === 'asc') {
        return aVal.localeCompare(bVal, 'ro', { numeric: true });
      } else {
        return bVal.localeCompare(aVal, 'ro', { numeric: true });
      }
    });
    
    return sorted;
  };

  // Transformări
  const transformations = [
    { value: '', label: '-- Selectați transformare --' },
    { value: 'uppercase', label: 'MAJUSCULE' },
    { value: 'lowercase', label: 'minuscule' },
    { value: 'capitalize', label: 'Prima Literă Mare' },
    { value: 'trim', label: 'Elimină spații' },
    { value: 'removeSpaces', label: 'Elimină toate spațiile' },
  ];

  const applyTransformation = () => {
    if (!selectedTransformColumn || !selectedTransformation) return;
    
    const newRows = rows.map(row => {
      const newRow = { ...row };
      const cellValue = String(row[selectedTransformColumn] || '');
      
      switch (selectedTransformation) {
        case 'uppercase':
          newRow[selectedTransformColumn] = cellValue.toUpperCase();
          break;
        case 'lowercase':
          newRow[selectedTransformColumn] = cellValue.toLowerCase();
          break;
        case 'capitalize':
          newRow[selectedTransformColumn] = cellValue
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
          break;
        case 'trim':
          newRow[selectedTransformColumn] = cellValue.trim();
          break;
        case 'removeSpaces':
          newRow[selectedTransformColumn] = cellValue.replace(/\s+/g, '');
          break;
        default:
          break;
      }
      
      return newRow;
    });
    
    setRows(newRows);
    setSelectedTransformColumn('');
    setSelectedTransformation('');
    alert('Transformare aplicată cu succes!');
  };

  // Verifică dacă coloana Jurist este mapată
  const isJuristColumnMapped = () => {
    return Object.values(columnMapping).includes('jurist');
  };

  // Verifică dacă coloana Jurist este mapată SAU dacă user-ul a activat manual assignment-ul
  const shouldShowUserAssignment = () => {
    return isJuristColumnMapped() || showUserAssignment;
  };

  // Găsește coloana Excel care e mapată la Jurist
  const getJuristExcelColumn = () => {
    return Object.keys(columnMapping).find(key => columnMapping[key] === 'jurist');
  };

  // Handler pentru assignment global de user
  const handleGlobalUserAssignment = (userId) => {
    setGlobalUserAssignment(userId);
    // Aplică la toate rândurile selectate
    const newAssignments = {};
    rows.forEach((_, index) => {
      if (selectedRows[index]) {
        newAssignments[index] = userId;
      }
    });
    setRowUserAssignments(prev => ({ ...prev, ...newAssignments }));
  };

  // Handler pentru assignment individual de user
  const handleRowUserAssignment = (rowIndex, userId) => {
    setRowUserAssignments(prev => ({
      ...prev,
      [rowIndex]: userId
    }));
  };

  return (
    <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
      <Box sx={{ flex: 1, p: 3, maxWidth: '100%', overflow: 'hidden' }}>
        <Typography variant="h5" gutterBottom>
          Import Custom - Vizualizare Date Excel {step === 2 && '- Pasul 2: Confirmare Mapări'}{step === 3 && '- Pasul 3: Previzualizare date'}
        </Typography>
        
        {step === 1 && (
          <>
            <Alert severity="info" variant="standard" sx={{ mb: 2 }}> 
              Selectați un fișier Excel pentru a vizualiza toate coloanele și datele.
            </Alert>

            <FileUpload onFileUpload={handleFileUpload} />

            {excelData && (
              <>
                <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
                  Fișier procesat cu succes: {rows.length} rânduri și {columns.length} coloane identificate.
                </Alert>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleReset}
                    startIcon={<ReplayIcon />}
                  >
                    Încarcă alt fișier
                  </Button>
                  <Button 
                    variant="contained" 
                    color="success" 
                    onClick={handleNextStep}
                    endIcon={<ArrowForwardIcon />}
                    disabled={!canProceedToNextStep()}
                  >
                    Următorul pas
                  </Button>
                </Box>

                {!canProceedToNextStep() && (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    Pentru a continua, trebuie să:
                    {!Object.values(selectedColumns).some(Boolean) && (
                      <li>Selectați cel puțin o coloană</li>
                    )}
                    {Object.values(selectedColumns).some(Boolean) && 
                     !columns.some(col => selectedColumns[col] && columnMapping[col] && columnMapping[col] !== '') && (
                      <li>Setați maparea pentru cel puțin o coloană selectată</li>
                    )}
                    {!Object.values(selectedRows).some(Boolean) && (
                      <li>Selectați cel puțin un rând din tabel</li>
                    )}
                  </Alert>
                )}

                {/* Find & Replace și Filtru */}
                <Box sx={{ mb: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                  <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Instrumente de procesare date
                  </Typography>
                  
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                    {/* Find & Replace */}
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, minWidth: 300 }}>
                      <TextField
                        size="small"
                        placeholder="Caută text..."
                        value={findText}
                        onChange={(e) => setFindText(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleFind()}
                        sx={{ flex: 1 }}
                      />
                      <TextField
                        size="small"
                        placeholder="Înlocuiește cu..."
                        value={replaceText}
                        onChange={(e) => setReplaceText(e.target.value)}
                        sx={{ flex: 1 }}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<FindReplaceIcon />}
                        onClick={handleFind}
                        disabled={!findText}
                      >
                        Caută
                      </Button>
                    </Box>

                    {/* Filtru Global */}
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1, minWidth: 300 }}>
                      <TextField
                        size="small"
                        placeholder="Filtrează rânduri..."
                        value={filterText}
                        onChange={(e) => handleFilterChange(e.target.value)}
                        sx={{ flex: 1 }}
                        InputProps={{
                          startAdornment: <FilterAltIcon sx={{ mr: 1, color: 'action.active' }} />
                        }}
                      />
                      {filterText && (
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<ClearIcon />}
                          onClick={handleClearFilter}
                          color="error"
                        >
                          Șterge
                        </Button>
                      )}
                    </Box>
                  </Box>

                  {/* Transformări */}
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                    <TransformIcon sx={{ color: 'action.active' }} />
                    <Typography variant="caption" sx={{ fontWeight: 'bold', mr: 1 }}>
                      Transformări:
                    </Typography>
                    <Autocomplete
                      options={columns}
                      value={selectedTransformColumn}
                      onChange={(event, newValue) => setSelectedTransformColumn(newValue || '')}
                      size="small"
                      sx={{ minWidth: 200 }}
                      renderInput={(params) => <TextField {...params} placeholder="Selectați coloana" />}
                    />
                    <Select
                      size="small"
                      value={selectedTransformation}
                      onChange={(e) => setSelectedTransformation(e.target.value)}
                      disabled={!selectedTransformColumn}
                      sx={{ minWidth: 200 }}
                    >
                      {transformations.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={applyTransformation}
                      disabled={!selectedTransformColumn || !selectedTransformation}
                    >
                      Aplică
                    </Button>
                  </Box>

                  {/* Dropdown global pentru Jurist */}
                  {shouldShowUserAssignment() && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 2, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>
                        Atribuire Jurist pentru toate rândurile selectate:
                      </Typography>
                      <Autocomplete
                        options={users}
                        getOptionLabel={(option) => option.name}
                        value={users.find(u => u.id === globalUserAssignment) || null}
                        onChange={(event, newValue) => handleGlobalUserAssignment(newValue?.id || null)}
                        size="small"
                        sx={{ minWidth: 250 }}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            placeholder="Selectați utilizatorul"
                            sx={{
                              '& .MuiInputBase-root': {
                                fontSize: '0.75rem',
                                padding: '2px 4px !important'
                              },
                              '& .MuiInputBase-input': {
                                padding: '4px 8px !important',
                                fontSize: '0.75rem'
                              }
                            }}
                          />
                        )}
                        ListboxProps={{
                          style: { fontSize: '0.75rem' }
                        }}
                      />
                      {!isJuristColumnMapped() && (
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          onClick={() => {
                            setShowUserAssignment(false);
                            setRowUserAssignments({});
                            setGlobalUserAssignment(null);
                          }}
                        >
                          Ascunde
                        </Button>
                      )}
                    </Box>
                  )}

                  {/* Buton pentru a activa assignment manual când Jurist nu e mapat */}
                  {!isJuristColumnMapped() && !showUserAssignment && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                      <Button
                        variant="contained"
                        color="info"
                        size="small"
                        onClick={() => setShowUserAssignment(true)}
                        startIcon={<PlayArrowIcon />}
                      >
                        Asociază dosarele la utilizatori
                      </Button>
                    </Box>
                  )}

                  {filterText && (
                    <Alert severity="info" sx={{ mt: 2 }}>
                      Filtru activ: {getTotalRowsCount()} rânduri găsite din {rows.length} total
                    </Alert>
                  )}
                </Box>

                <TableContainer 
                  component={Paper} 
                  sx={{ 
                    maxHeight: 'calc(100vh - 400px)',
                    width: '100%',
                    overflowX: 'auto',
                    overflowY: 'auto'
                  }}
                >
                  <Table stickyHeader sx={{ width: '100%', tableLayout: 'auto' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell 
                          sx={{ 
                            fontWeight: 'bold', 
                            backgroundColor: '#2c3e50 !important', 
                            color: 'white',
                            position: 'sticky',
                            left: 0,
                            zIndex: 3,
                            borderRight: '1px solid #34495e',
                            textAlign: 'center'
                          }}
                        >
                          <Checkbox
                            checked={Object.keys(selectedRows).length === rows.length && Object.values(selectedRows).every(Boolean)}
                            indeterminate={Object.values(selectedRows).some(Boolean) && !Object.values(selectedRows).every(Boolean)}
                            onChange={handleSelectAllRows}
                            sx={{
                              color: 'white',
                              padding: 0,
                              '&.Mui-checked': {
                                color: '#4caf50',
                              },
                              '&.MuiCheckbox-indeterminate': {
                                color: '#ff9800',
                              },
                            }}
                          />
                        </TableCell>
                        {columns.map((column, index) => (
                          <TableCell 
                            key={index}
                            sx={{ 
                              backgroundColor: selectedColumns[column] ? '#c8e6c9 !important' : '#2c3e50 !important', 
                              color: selectedColumns[column] ? '#1b5e20 !important' : 'white !important',
                              minWidth: 200,
                              maxWidth: 350,
                              whiteSpace: 'nowrap',
                              borderRight: index < columns.length - 1 ? '1px solid #34495e' : 'none',
                              padding: '8px',
                              transition: 'background-color 0.3s ease'
                            }}
                          >
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Checkbox
                                  checked={selectedColumns[column] || false}
                                  onChange={(e) => handleColumnSelectionChange(column, e.target.checked)}
                                  sx={{
                                    color: selectedColumns[column] ? '#1b5e20' : 'white',
                                    padding: 0,
                                    '&.Mui-checked': {
                                      color: '#2e7d32',
                                    },
                                  }}
                                />
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    fontWeight: 'bold', 
                                    fontSize: '0.875rem', 
                                    color: selectedColumns[column] ? '#1b5e20 !important' : 'white !important',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    '&:hover': {
                                      textDecoration: 'underline'
                                    }
                                  }}
                                  onClick={() => handleColumnHeaderClick(column)}
                                >
                                  {column}
                                </Typography>
                              </Box>
                              <FormControl size="small" fullWidth>
                                <Autocomplete
                                  options={availableColumns}
                                  getOptionLabel={(option) => option.label}
                                  value={availableColumns.find(opt => opt.value === columnMapping[column]) || availableColumns[0]}
                                  onChange={(event, newValue) => handleColumnMappingChange(column, newValue?.value || '')}
                                  disabled={!selectedColumns[column]}
                                  disableClearable
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField 
                                      {...params} 
                                      sx={{
                                        backgroundColor: 'white',
                                        '& .MuiInputBase-root': {
                                          fontSize: '0.75rem',
                                          padding: '0 !important'
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '4px 8px !important'
                                        }
                                      }}
                                    />
                                  )}
                                  sx={{
                                    '& .MuiAutocomplete-input': {
                                      fontSize: '0.75rem'
                                    }
                                  }}
                                  ListboxProps={{
                                    style: { fontSize: '0.75rem' }
                                  }}
                                />
                              </FormControl>
                            </Box>
                          </TableCell>
                        ))}
                        {shouldShowUserAssignment() && (
                          <TableCell 
                            sx={{ 
                              fontWeight: 'bold', 
                              backgroundColor: '#2c3e50 !important', 
                              color: 'white',
                              minWidth: 200,
                              position: 'sticky',
                              right: 0,
                              zIndex: 3,
                              borderLeft: '2px solid #34495e'
                            }}
                          >
                            <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>
                              Atribuire Jurist
                            </Typography>
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {getDisplayRows().map((row, rowIndex) => {
                        const actualRowIndex = getActualRowIndex(rowIndex);
                        return (
                          <TableRow 
                            key={actualRowIndex}
                            sx={{ 
                              '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                              opacity: selectedRows[actualRowIndex] ? 1 : 0.5
                            }}
                          >
                            <TableCell 
                              sx={{ 
                                fontWeight: 'bold',
                                position: 'sticky',
                                left: 0,
                                backgroundColor: rowIndex % 2 === 0 ? 'white' : '#f5f5f5',
                                zIndex: 1,
                                textAlign: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                                <Checkbox
                                  checked={selectedRows[actualRowIndex] || false}
                                  onChange={(e) => handleRowSelectionChange(actualRowIndex, e.target.checked)}
                                  size="small"
                                  sx={{
                                    padding: 0,
                                    '&.Mui-checked': {
                                      color: '#4caf50',
                                    },
                                  }}
                                />
                                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                  {actualRowIndex + 1}
                                </Typography>
                              </Box>
                            </TableCell>
                            {columns.map((column, colIndex) => (
                              <TableCell 
                                key={colIndex}
                                sx={{ 
                                  minWidth: 200,
                                  maxWidth: 350,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  backgroundColor: selectedColumns[column] ? '#e8f5e9' : 'inherit'
                                }}
                              >
                                {row[column] !== undefined && row[column] !== null ? String(row[column]) : '-'}
                              </TableCell>
                            ))}
                            {shouldShowUserAssignment() && (
                              <TableCell 
                                sx={{ 
                                  minWidth: 200,
                                  position: 'sticky',
                                  right: 0,
                                  backgroundColor: rowIndex % 2 === 0 ? 'white' : '#f5f5f5',
                                  zIndex: 1,
                                  borderLeft: '2px solid #e0e0e0'
                                }}
                              >
                                <Autocomplete
                                  options={users}
                                  getOptionLabel={(option) => option.name}
                                  value={users.find(u => u.id === rowUserAssignments[actualRowIndex]) || null}
                                  onChange={(event, newValue) => handleRowUserAssignment(actualRowIndex, newValue?.id || null)}
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField 
                                      {...params} 
                                      placeholder="Atribuie jurist"
                                      sx={{
                                        '& .MuiInputBase-root': {
                                          fontSize: '0.75rem',
                                          padding: '0 !important'
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '4px 8px !important',
                                          fontSize: '0.75rem'
                                        }
                                      }}
                                    />
                                  )}
                                  ListboxProps={{
                                    style: { fontSize: '0.75rem' }
                                  }}
                                />
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>

                {getTotalPages() > 1 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination 
                      count={getTotalPages()} 
                      page={currentPage} 
                      onChange={handlePageChange}
                      color="primary"
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}

                <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}>
                  Afișate: {(currentPage - 1) * rowsPerPage + 1}-{Math.min(currentPage * rowsPerPage, getTotalRowsCount())} din {getTotalRowsCount()} rânduri × {columns.length} coloane
                  <br />
                  <strong>Selectate:</strong> {Object.values(selectedRows).filter(Boolean).length} rânduri, {Object.values(selectedColumns).filter(Boolean).length} coloane
                </Typography>
              </>
            )}
          </>
        )}

        {step === 2 && (
          <>
            <Alert severity="info" variant="standard" sx={{ mb: 2 }}> 
              Verificați mapările coloanelor selectate înainte de a continua.
            </Alert>

            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                Coloane selectate și mapări: {getSelectedColumnsData().length} coloane
              </Typography>
              
              <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 350px)' }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white' }}>
                        Nr.
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white' }}>
                        Coloană Excel
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white' }}>
                        Mapată la
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white' }}>
                        Exemplu date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getSelectedColumnsData().map((column, index) => (
                      <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' } }}>
                        <TableCell sx={{ fontWeight: 'bold' }}>{index + 1}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#1976d2' }}>{column}</TableCell>
                        <TableCell sx={{ color: columnMapping[column] ? '#2e7d32' : '#d32f2f' }}>
                          {getMappedColumnLabel(column)}
                        </TableCell>
                        <TableCell sx={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {rows[0] && rows[0][column] !== undefined && rows[0][column] !== null 
                            ? String(rows[0][column]) 
                            : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button 
                variant="contained" 
                color="warning" 
                onClick={handlePrevStep}
                startIcon={<ArrowBackIcon />}
              >
                Înapoi
              </Button>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleReset}
                  startIcon={<ReplayIcon />}
                >
                  Încarcă alt fișier
                </Button>
                <Button 
                  variant="contained" 
                  color="success" 
                  onClick={() => { setStep(3); setCurrentPage(1); }}
                  endIcon={<ArrowForwardIcon />}
                >
                  Previzualizare date
                </Button>
              </Box>
            </Box>
          </>
        )}

        {step === 3 && (
          <>
            <Alert severity="info" variant="standard" sx={{ mb: 2 }}>
              Verificați datele finale înainte de a lansa importul. Sunt afișate doar coloanele mapate și rândurile selectate.
            </Alert>

            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
              <strong>{Object.values(selectedRows).filter(Boolean).length}</strong> dosare × <strong>{columns.filter(col => selectedColumns[col] && columnMapping[col] && columnMapping[col] !== '').length}</strong> coloane mapate
            </Typography>

            <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 320px)', width: '100%', overflowX: 'auto' }}>
              <Table stickyHeader size="small" sx={{ tableLayout: 'auto' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white', minWidth: 50 }}>
                      Nr.
                    </TableCell>
                    {columns.filter(col => selectedColumns[col] && columnMapping[col] && columnMapping[col] !== '').map((col, idx) => (
                      <TableCell key={idx} sx={{ fontWeight: 'bold', backgroundColor: '#2c3e50 !important', color: 'white', minWidth: 150 }}>
                        {getMappedColumnLabel(col)}
                        <Typography variant="caption" sx={{ display: 'block', color: '#aaa', fontSize: '10px' }}>
                          ({col})
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.filter((_, index) => selectedRows[index]).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((row, rowIdx) => (
                    <TableRow key={rowIdx} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' } }}>
                      <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>
                        {(currentPage - 1) * rowsPerPage + rowIdx + 1}
                      </TableCell>
                      {columns.filter(col => selectedColumns[col] && columnMapping[col] && columnMapping[col] !== '').map((col, colIdx) => (
                        <TableCell key={colIdx} sx={{ fontSize: '12px', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {row[col] !== undefined && row[col] !== null ? String(row[col]) : '-'}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {Math.ceil(Object.values(selectedRows).filter(Boolean).length / rowsPerPage) > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(Object.values(selectedRows).filter(Boolean).length / rowsPerPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                />
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button 
                variant="contained" 
                color="warning" 
                onClick={() => { setStep(2); setCurrentPage(1); }}
                startIcon={<ArrowBackIcon />}
              >
                Înapoi la mapări
              </Button>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleReset}
                  startIcon={<ReplayIcon />}
                >
                  Încarcă alt fișier
                </Button>
                <Button 
                  variant="contained" 
                  color="success" 
                  onClick={handleStartImport}
                  startIcon={<PlayArrowIcon />}
                >
                  Începeți importul
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Box>

      {/* Modal pentru progres import */}
      <Dialog 
        open={importProgress !== null} 
        onClose={importProgress !== 'loading' ? handleCloseJsonModal : undefined}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className='titluModal'>
          <Typography variant="h6" sx={{ color: 'white' }}>
            {importProgress === 'loading' && 'Se procesează importul...'}
            {importProgress === 'success' && 'Import realizat cu succes'}
            {importProgress === 'error' && 'Atenționare'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {importProgress === 'loading' && (
            <Box sx={{ py: 3 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Se importă dosarele... {importCompleted} din {importTotal} procesate
                {importErrors.length > 0 && `, ${importErrors.length} necesită atenție`}
              </Typography>
              <Box sx={{ position: 'relative', mb: 1 }}>
                <Box sx={{ height: 20, borderRadius: 5, backgroundColor: '#e0e0e0', overflow: 'hidden' }}>
                  <Box sx={{ 
                    height: '100%', 
                    width: `${importPercent}%`, 
                    backgroundColor: importPercent === 100 ? '#4caf50' : '#1976d2',
                    transition: 'width 0.3s ease, background-color 0.3s ease',
                    borderRadius: 5
                  }} />
                </Box>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    position: 'absolute', top: '50%', left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    fontWeight: 'bold', fontSize: '0.875rem',
                    color: importPercent > 50 ? '#fff' : '#000'
                  }}
                >
                  {importPercent}%
                </Typography>
              </Box>
            </Box>
          )}
          {importProgress === 'success' && (
            <Alert severity="success" sx={{ mt: 1 }}>
              {importMessage}
            </Alert>
          )}
          {importProgress === 'error' && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {importMessage}
            </Alert>
          )}
          {importErrors.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Alert severity="warning" sx={{ mb: 1 }}>
                Atenționare: {importErrors.length} {importErrors.length === 1 ? 'dosar nu a fost importat' : 'dosare nu au fost importate'}
              </Alert>
              <TableContainer component={Paper} sx={{ maxHeight: 200 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }}>Rândul</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Motiv</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', width: 80 }}>Acțiune</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importErrors.map((err, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{err.row}</TableCell>
                        <TableCell sx={{ fontSize: '12px' }}>{err.message}</TableCell>
                        <TableCell>
                          <Tooltip title="Reîncearcă importul">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleRetryImport(err)}
                              disabled={retryingRow === err.row}
                            >
                              <ReplayIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Rezumat:</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Rânduri selectate: {Object.values(selectedRows).filter(Boolean).length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Coloane mapate: {columns.filter(col => selectedColumns[col] && columnMapping[col] && columnMapping[col] !== '').length}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          {importProgress !== 'loading' && (
            <Button onClick={handleCloseJsonModal} color="primary">
              Închide
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Dialog pentru Find & Replace */}
      <Dialog 
        open={showReplaceDialog} 
        onClose={handleCancelReplace}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Confirmare înlocuire
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            S-au găsit <strong>{findResults?.count || 0}</strong> apariții ale textului "<strong>{findText}</strong>".
          </Alert>
          <Typography variant="body2" gutterBottom>
            Doriți să înlocuiți toate aparițiile cu "<strong>{replaceText}</strong>"?
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            Această acțiune va modifica datele din tabel și nu poate fi anulată.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReplace} color="inherit">
            Anulează
          </Button>
          <Button onClick={handleReplace} variant="contained" color="primary">
            Înlocuiește toate
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ImportCustom;
 